import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconArrowRight';
/** Renders an SVG icon. */
const SvgArrowRight = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 16a1 1 0 0 0 1 1h21.394l-8.063 7.257a1 1 0 1 0 1.338 1.486l10-9a1 1 0 0 0 0-1.486l-10-9a1 1 0 0 0-1.338 1.486L25.394 15H4a1 1 0 0 0-1 1"
      />
    </svg>
  );
};
SvgArrowRight.displayName = displayName;
export default SvgArrowRight;
